/**
 * Utilitaire pour gérer le thème de l'application
 */

// Récupérer le thème actuel
export const getTheme = () => {
  const theme = localStorage.getItem('theme') || getPreferredTheme();
  return theme;
};

// Définir le thème préféré par défaut (basé sur les préférences système)
export const getPreferredTheme = () => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

// Basculer entre thème clair et sombre
export const toggleTheme = () => {
  const currentTheme = getTheme();
  const newTheme = currentTheme === 'light' ? 'dark' : 'light';
  
  // Enregistrer dans localStorage
  localStorage.setItem('theme', newTheme);
  
  // Appliquer le thème
  applyTheme(newTheme);
  
  // Émettre un événement pour que les autres composants puissent réagir
  window.dispatchEvent(new CustomEvent('themeChanged', { detail: newTheme }));
  
  return newTheme;
};

// Appliquer un thème spécifique
export const applyTheme = (theme) => {
  // Utiliser directement les noms de thème standard light/dark
  document.documentElement.setAttribute('data-theme', theme);
};

// Initialiser le thème au démarrage de l'application
export const initTheme = () => {
  const theme = getTheme();
  applyTheme(theme);
};